import React, { useContext } from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { LearningActivityCard } from "Components/Module/LearningActivityItem";
import {
  getCardTitle,
  formatCourseDuration,
  renderTimeDisplay,
  getCardImage,
} from "Components/Module/LearningActivityItem/functions";
import { Box } from "Components/Base/Layout/Box";
import Rating from "lib/components/Rating";
import {
  useCourseCompletion,
  GetRequestedCourseLink,
} from "../../../../functions";
import LangContext from "../../../../langContext";
import { STYLE_CARD_HEADING } from "../../style";
import { ProgramChips } from "./CardChips";
import CourseReason from "./CourseReason";

const ProgamCard = (props) => {
  const languageContext = useContext(LangContext);
  const { course, displayImage, activityId, isPortalOverview, isPreview } =
    props;

  const [completed, setCompleted] = useCourseCompletion(course);
  const displayTime = formatCourseDuration(course, languageContext);

  const { imageComponent } = getCardImage(
    course,
    displayImage,
    isPortalOverview,
  );

  const cardTitle = getCardTitle(course, isPortalOverview);

  return (
    <LearningActivityCard
      id={`learningActivityCard${course.courseId}`}
      title={cardTitle}
      type={course.type}
      displayImage={displayImage}
      imageComponent={imageComponent}
      chips={
        <ProgramChips
          course={course}
          completed={completed}
          languageContext={languageContext}
          isPortalOverview={isPortalOverview}
        />
      }
      content={
        <>
          <div>
            <Typography variant="h4" sx={STYLE_CARD_HEADING}>
              {languageContext("program")}
            </Typography>
            <Rating
              currentRating={course.avgRating}
              noOfRatings={course.noOfRatings}
              readOnly={true}
            />
            <CourseReason
              reason={course.reason}
              label={`${languageContext("reason")}: \n`}
            />
            <Box display="flex" justifyContent="center" width="100%">
              {renderTimeDisplay(displayTime)}
            </Box>
          </div>
        </>
      }
      actions={
        <>
          {((course.isActiveStep && !isPreview) || isPortalOverview) && (
            <GetRequestedCourseLink
              courseId={course.courseObjectId}
              activityId={activityId}
              label={languageContext("showprogram")}
              isPortalOverview={isPortalOverview}
            />
          )}
        </>
      }
    />
  );
};

export default ProgamCard;
